

export function exists(val:any):boolean{
    if(val === undefined){
        return false;
    }
    if(val === null){
        return false;
    }
    return true;
}

export function has(obj:any, key:string){
    return obj.hasOwnProperty(key);
}

// accepts the booleans that arrive from outside the app, where a flag may be sent
// as a real boolean or as the string "true".
export function is_true(val:any):boolean{
    if(val === true){
        return true;
    }
    if(typeof(val) === typeof("")){
        return (<string>val).toLowerCase() === "true";
    }
    return false;
}

export function random_bool():boolean{
    return 0 === Math.floor(Math.random()*10%2);
}